import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import type { ResourceLink, SocialLink } from './footer.types';

export const socialLinks: SocialLink[] = [
  { icon: FaTwitter, href: 'https://x.com/7SigmaCompanies', label: 'Twitter' },
  { icon: FaGithub, href: 'https://github.com/7sigmallc', label: 'GitHub' },
  { icon: FaLinkedin, href: 'https://linkedin.com/company/7sigma-companies', label: 'LinkedIn' },
  // { icon: FaMedium, href: 'https://medium.com/@7sigma', label: 'Medium' },
];

export const resourceLinks: ResourceLink[] = [
  {
    href: '/a-practical-guide-to-building-agents.pdf',
    label: 'OpenAI Agents Guide',
    target: '_blank',
  },
  {
    href: '/assets/State_of_AI_in_Business_2025_Report.pdf',
    label: 'State of AI 2025 Report',
    target: '_blank',
  },
];

export const quickLinks: ResourceLink[] = [
  // { href: '/', label: 'Home' },
  { href: '/services', label: 'Services' },
  { href: '/contact/advisory', label: 'Advisory' },
  { href: '/contact', label: 'Contact' },
  { href: '/blog', label: 'Blog' },
  { href: 'https://news.7sigma.io', label: 'News' },
  // { href: '/contact/general', label: 'General Inquiry' },
  // { href: '/contact/client/build', label: 'Build with Us' },
];
